import React from 'react';
import './AboutCard.css'
import '../../root.css'

const AboutCard = (props) => {
    return ( 
        <div className='AboutCard'>
            <p className='CardName'>{props.CardName}</p>
            <p className='CardNum'>{props.CardNum}</p>
            <p className='CardSub'>{props.CardSub}</p>
        </div>
     );
}
 
export default AboutCard;